<template>
  <v-row justify="center">
    <v-dialog
      v-model="isTheModalOpen"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      @keydown.esc="emitCloseModal"
    >
      <v-card>
        <!-- Toolbar -->
        <v-toolbar dark color="#3cbc62">
          <v-toolbar-title>{{ modalTitleToolbar }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="emitExcel">
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>
          <v-btn icon dark @click="emitCloseModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <slot></slot>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    isTheModalOpen: Boolean,
    modalTitleToolbar: String,
  },

  methods: {
    emitCloseModal() {
      this.$emit("fecharModal");
    },
    emitExcel() {
      this.$emit("generate-excel")
    }
  },
};
</script>